<template>
  <b-row>
    <b-col lg="12">
      <b-card header="Detalle">
        <b-row>
          <b-col sm="8">
            <h4>GENERAL</h4>
            <br />
            <table class="table table-hover table_rq">
              <tbody>
                <tr>
                  <th>Cliente</th>
                  <td>{{ service.company.name }}</td>
                </tr>
                <tr>
                  <th>Servicio</th>
                  <td>{{ service.service_type.name }}</td>
                </tr>
                <tr>
                  <th>Referencia (para facturación)</th>
                  <td>{{ service.reference }}</td>
                </tr>
                <tr v-if="service.service_type.code === constants.EXPORTACION">
                  <th>Llenado en almacén</th>
                  <td>{{ fill ? "SI" : "NO" }}</td>
                </tr>
                <tr>
                  <th>Línea naviera</th>
                  <td>
                    {{
                      service.shipping_line ? service.shipping_line.name : ""
                    }}
                  </td>
                </tr>
                <tr>
                  <th>
                    {{
                      service_type.code === constants.IMPORTACION
                        ? "Número BL"
                        : "Número Booking"
                    }}
                  </th>
                  <td>{{ service.doc_number }}</td>
                </tr>
                <tr>
                  <th>Comentarios</th>
                  <td style="white-space: pre-line;">{{ service.comments }}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <div v-if="user.role.code !== constants.SOLICITANTE">
          <hr />
          <h4>DOCUMENTACION</h4>
          <br />
          <b-row
            class="form-group"
            v-if="service_type.code === constants.IMPORTACION"
          >
            <b-col cols="5">
              <label for>
                <input type="checkbox" v-model="service.check_bl" /> BL
              </label>
            </b-col>
          </b-row>
          <b-row
            class="form-group"
            v-if="service_type.code === constants.IMPORTACION"
          >
            <b-col cols="5">
              <label for>
                <input type="checkbox" v-model="service.check_memo" /> Memo
              </label>
            </b-col>
          </b-row>
          <b-row
            class="form-group"
            v-if="service_type.code === constants.EXPORTACION"
            accept="application/pdf"
          >
            <b-col cols="5">
              <label for>
                <input type="checkbox" v-model="service.check_booking" />
                Booking
              </label>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col cols="5">
              <label for>
                <input type="checkbox" v-model="service.check_referral_guide" />
                Guía de remisión
              </label>
            </b-col>
          </b-row>
          <b-row class="form-group">
            <b-col cols="5">
              <label for>
                <input type="checkbox" v-model="service.check_dam" /> DAM
                (Declaración Aduanera de Mercancia)
              </label>
            </b-col>
          </b-row>
          <b-row
            v-if="service_type.code === constants.IMPORTACION"
            class="form-group"
          >
            <b-col class="custom-control custom-checkbox" cols="5">
              <label for>
                <b-badge :variant="service.tax_gate_in ? 'success' : 'warning'"
                  >Gate In {{ service.tax_gate_in ? "pagado" : "no pagado" }}
                </b-badge>
              </label>
            </b-col>
          </b-row>
          <b-row
            v-if="service_type.code === constants.EXPORTACION"
            class="form-group"
          >
            <b-col class="custom-control custom-checkbox" cols="5">
              <label for>
                <b-badge :variant="service.tax_gate_out ? 'success' : 'warning'"
                  >Gate Out {{ service.tax_gate_out ? "pagado" : "no pagado" }}
                </b-badge>
              </label>
            </b-col>
          </b-row>
        </div>
        <hr />
        <h4>CONTENEDORES</h4>
        <br />
        <b-row class="form-group">
          <b-col cols="12">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Fecha de entrega</th>
                    <th
                      v-if="service.service_type.code === constants.IMPORTACION"
                    >
                      Sobre estadía
                    </th>
                    <th
                      v-if="
                        !(service.arr_expo || service.arr_impo) &&
                          !fill &&
                          [
                            constants.IMPORTACION,
                            constants.EXPORTACION
                          ].includes(service.service_type.code)
                      "
                    >
                      Dirección
                    </th>
                    <th>Contenedor</th>
                    <th>Terminal de retiro</th>
                    <th>
                      Terminal de
                      {{
                        `${
                          service_type.code === constants.IMPORTACION
                            ? "devolución"
                            : "entrega Full"
                        }`
                      }}
                    </th>
                    <th>Tamaño</th>
                    <th>Tipo de carga</th>
                    <th>Camión</th>
                    <th>Conductor</th>
                    <th>Resguardo</th>
                    <th>Estado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(rq, j) in paginated('rqs')"
                    :key="j"
                    @contextmenu.prevent="selectRq(rq)"
                  >
                    <td>{{ rq.date | formatDateTime }}</td>
                    <td
                      v-if="service.service_type.code === constants.IMPORTACION"
                    >
                      <date-picker
                        v-model="rq.container_expiration"
                        lang="es"
                        placeholder="Fecha de Sobre estadía"
                        type="date"
                        format="DD/MM/YYYY"
                        @change="setField(rq, 'container_expiration')"
                      ></date-picker>
                    </td>
                    <td
                      v-if="
                        !(service.arr_expo || service.arr_impo) &&
                          !fill &&
                          [
                            constants.IMPORTACION,
                            constants.EXPORTACION
                          ].includes(service.service_type.code)
                      "
                    >
                      {{ rq.address.alias }}
                    </td>
                    <td>{{ rq.container_number }}</td>
                    <td>
                      <select
                        v-if="
                          (rq.charge_type &&
                            rq.charge_type.name !== constants.SUELTA) ||
                            rq.deposit_pick_id
                        "
                        v-model="rq.deposit_pick_id"
                        v-on:change="setField(rq, 'deposit_pick_id')"
                        class="form-control"
                        :disabled="user.role.code === constants.SOLICITANTE"
                      >
                        <option
                          v-for="(deposit, k) in deposits"
                          :key="k"
                          :value="deposit.id"
                          >{{ deposit.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      <select
                        v-if="
                          rq.charge_type &&
                            rq.charge_type.name !== constants.SUELTA
                        "
                        v-model="rq.deposit_id"
                        v-on:change="setField(rq, 'deposit_id')"
                        class="form-control"
                        :disabled="user.role.code === constants.SOLICITANTE"
                      >
                        <option
                          v-for="(deposit, k) in deposits"
                          :key="k"
                          :value="deposit.id"
                          >{{ deposit.name }}
                        </option>
                      </select>
                    </td>
                    <td>
                      {{
                        rq.charge_type &&
                        rq.charge_type.name === constants.SUELTA
                          ? "--"
                          : rq.container_size
                          ? rq.container_size.name
                          : "--"
                      }}
                    </td>
                    <td>{{ rq.charge_type ? rq.charge_type.name : "--" }}</td>
                    <td>{{ rq.truck ? rq.truck.plate : "" }}</td>
                    <td>
                      {{
                        rq.driver
                          ? `${rq.driver.name} ${rq.driver.last_name}`
                          : ""
                      }}
                    </td>
                    <td>
                      {{
                        rq.guard
                          ? rq.custody
                            ? rq.custody.name
                            : "Si, custodia no indicada"
                          : "No"
                      }}
                    </td>
                    <td>{{ rq.status.name }}</td>
                  </tr>
                </tbody>
              </table>
              <context-menu ref="ctxMenu" id="context-menu">
                <li class="ctx-item" @click="detailRq()">Ver detalle</li>
                <li class="ctx-item" @click="editRq()">Modificar</li>
              </context-menu>
              <paginate
                name="rqs"
                :list="rqs"
                class="paginate-list"
                :per="10"
              ></paginate>
              <paginate-links
                for="rqs"
                :limit="5"
                :show-step-links="true"
                :step-links="{
                  next: '>>',
                  prev: '<<'
                }"
                :classes="{
                  ul: 'pagination',
                  li: 'page-item',
                  a: 'page-link'
                }"
              ></paginate-links>
            </div>
          </b-col>
        </b-row>
        <div
          slot="footer"
          v-if="
            ![
              constants.SOLICITANTE,
              constants.EJECUTIVO_CUENTA,
              constants.PLANIFICADOR
            ].includes(user.role.code)
          "
        >
          <b-button
            v-if="
              status.code === constants.PENDIENTE &&
                service_type.code !== constants.POSICIONAMIENTOS
            "
            @click="approve()"
            type="button"
            variant="primary"
            >Aprobar </b-button
          >&nbsp;
          <b-button
            v-if="status.code === constants.PENDIENTE"
            @click="cancel()"
            type="button"
            variant="danger"
            >Anular </b-button
          >&nbsp;
          <b-button
            v-if="
              (service.service_type.code === constants.IMPORTACION &&
                !service.tax_gate_in) ||
                (service.service_type.code === constants.EXPORTACION &&
                  !service.tax_gate_out)
            "
            @click="payment()"
            type="button"
            variant="primary"
            >{{ `Registro de ${paymentText}` }}
          </b-button>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import router from "@/router";
import moment from "moment";
import { mapGetters } from "vuex";
import contextMenu from "vue-context-menu";

export default {
  components: { contextMenu },
  data() {
    return {
      id: this.$route.params.id,
      constants: {},
      service: {
        company: {},
        service_type: {},
        driver: {},
        status: {},
        deposit: {},
        shipping_line: {}
      },
      fill: false,
      paginate: ["rqs"],
      rqs: [],
      rq: {},
      hasStow: null,
      status_logs: [],
      service_type: {},
      deposits: [],
      status: {},
      originalRqId: null,
      paymentText: "",
      showModalStow: false
    };
  },
  computed: {
    ...mapGetters({ user: "user/user" })
  },
  methods: {
    approve() {
      if (this.service.service_type.code === constants.IMPORTACION) {
        if (
          !this.service.check_bl ||
          !this.service.check_memo ||
          !this.service.check_dam ||
          !this.service.check_referral_guide
        ) {
          this.$toastr.info(
            "Para aprobar el servicio todos los documentos deben estar chequeados.",
            "",
            {
              positionClass: "toast-top-center",
              closeButton: true
            }
          );
          return;
        }

        this.updateService(
          {
            check_bl: this.service.check_bl,
            check_memo: this.service.check_memo,
            check_dam: this.service.check_dam,
            check_referral_guide: this.service.check_referral_guide,
            status_id: this.approvedStatus.id,
            requeriments: JSON.stringify(this.rqs)
          },
          "Requerimiento aprobado"
        );
      } else if (this.service.service_type.code === constants.EXPORTACION) {
        if (
          !this.service.check_booking ||
          !this.service.check_dam ||
          !this.service.check_referral_guide
        ) {
          this.$toastr.info(
            "Para aprobar el servicio todos los documentos deben estar chequeados.",
            "",
            {
              positionClass: "toast-top-center",
              closeButton: true
            }
          );
          return;
        }
        this.updateService(
          {
            check_booking: this.service.check_booking,
            check_dam: this.service.check_dam,
            check_referral_guide: this.service.check_referral_guide,
            status_id: this.approvedStatus.id,
            requeriments: JSON.stringify(this.rqs)
          },
          "Requerimiento aprobado"
        );
      }
    },
    cancel() {
      let data_rqs = [];
      this.rqs.map(rq => {
        data_rqs.push({ id: rq.id, date: rq.date });
      });

      this.updateService(
        {
          status_id: this.cancelledStatus.id,
          requeriments: JSON.stringify(data_rqs)
        },
        "Requerimiento anulado"
      );
    },
    payment() {
      let data = {};
      if (this.service.service_type.code === constants.IMPORTACION)
        data = { tax_gate_in: true };
      else data = { tax_gate_out: true };
      this.updateService(data, "Requerimiento pagado", false);
    },
    updateService(data, text, reload = true) {
      api.put(`/service/${this.id}`, data).then(response => {
        if (response.success) {
          this.setService(response);
          this.$toastr.success(text, "", {
            positionClass: "toast-top-center",
            closeButton: true
          });
          if (reload)
            this.$router.push({
              path: `/services/all-pending`
            });
        }
      });
    },
    selectRq(rq) {
      this.rq = rq;
      this.$refs.ctxMenu.open();
    },
    detailRq() {
      this.$router.push({
        path: `/requeriments/${
          this.service.service_type.code === constants.EXPORTACION
            ? "export"
            : "import"
        }/detail/${this.rq.id}`
      });
    },
    editRq() {
      this.$router.push({
        path: `/requeriment/edit/${this.rq.id}`
      });
    },
    createStow(rq) {
      this.showModalStow = true;
      this.rq = rq;
    },
    closeModal(has_stow) {
      // console.log(has_stow);
      this.showModalStow = false;
      this.hasStow = has_stow;
    },
    viewFile(folder, filename) {
      const APIURL = process.env.VUE_APP_SOCKET;
      window.open(`${APIURL}${folder}/${filename}`);
    },
    setService(response) {
      this.rqs = response.requeriments;
      this.fill = response.requeriments.some(rq => rq.fill);
      this.service = response.service;
      this.service_type = this.service.service_type;
      this.status = this.service.status;
      this.hasStow = response.has_stow;
      if (this.hasStow) this.stowId = response.stow.id;
      if (response.service.original)
        this.originalRqId = response.service.original.id;
    },
    setField(rq, field) {
      let data = {};
      switch (field) {
        case "container_expiration":
          data = {
            container_expiration: moment(rq.container_expiration).isValid()
              ? moment(rq.container_expiration).format("YYYY-MM-DD")
              : null
          };
          break;
        case "deposit_id":
          data = { deposit_id: rq.deposit_id };
          break;
        case "deposit_pick_id":
          data = { deposit_pick_id: rq.deposit_pick_id };
          break;
      }

      api.put(`/requeriments/${rq.id}`, data).then(response => {
        if (response.success) {
          console.log("actualizado");
        }
      });
    }
  },
  mounted() {
    this.constants = constants;
    api.get(`/service/${this.id}`).then(response => {
      if (response.service.service_type.code === constants.IMPORTACION)
        this.paymentText = "gate in";
      else this.paymentText = "gate out";
      if (response.success) this.setService(response);
    });

    api.get("/deposits").then(response => {
      this.deposits = response.deposits;
    });

    api.get(`/statuses`).then(response => {
      const statuses = response.status;
      this.approvedStatus = statuses.find(x => x.code === constants.APROBADO);
      this.cancelledStatus = statuses.find(
        x => x.code === constants.ANULADO_TRAMARSA
      );
    });

    api.get(`/status_logs/${this.id}`).then(response => {
      this.status_logs = response.status_logs;
      this.status_logs.map(st_log => {
        st_log.diff = "--";
        if (st_log.previous) {
          let ms = moment(st_log.created_at).diff(
            moment(st_log.previous.created_at)
          );
          if (ms > 0) {
            var d = moment.duration(ms);
            var dur = moment.duration(d, "hours");
            var hours = Math.floor(dur.asHours());
            var mins = Math.floor(dur.asMinutes()) - hours * 60;

            st_log.diff =
              (hours > 9 ? hours : "0" + hours) +
              ":" +
              (mins > 9 ? mins : "0" + mins);
          } else {
            st_log.diff = "00:00";
          }
        }
        return st_log;
      });
    });
  }
};
</script>

<style scoped>
.data_rq th {
  text-transform: uppercase;
  width: 45%;
}

.data_rq td {
  font-weight: 100;
}
.mx-datepicker >>> .mx-datepicker-popup {
  top: 0 !important;
}
</style>
